<div class="input-label">
  {{ translationPrefix() + 'category' | translate }}
</div>
<p-select
  [options]="categories"
  [(ngModel)]="selectedCategory"
  optionLabel="name"
  [placeholder]="translationPrefix() + 'categoryPlaceholder' | translate"
  class="category-select" />

@if (selectedCategory) {
  <div class="category-info-wrapper">
    <img class="category-info-wrapper__icon" src="assets/icons/folder.svg" />
    <h3 class="callout-text">
      {{ translationPrefix() + 'categoryInfoHeading' | translate }}
    </h3>

    @switch (selectedCategory.id) {
      @case ('PROPERTY') {
        <app-real-estate-template-info [translationPrefix]="translationPrefix()" />
      }
      @case ('ALCOHOL') {
        <app-alcohol-template-info [translationPrefix]="translationPrefix()"></app-alcohol-template-info>
      }
      @case ('JEWELS') {
        <app-jewels-template-info [translationPrefix]="translationPrefix()"></app-jewels-template-info>
      }
      @case ('CAR') {
        <app-car-template-info [translationPrefix]="translationPrefix()"></app-car-template-info>
      }
      @case ('GEMSTONE') {
        <app-gemstone-template-info [translationPrefix]="translationPrefix()"></app-gemstone-template-info>
      }
      @case ('INSTRUMENT') {
        <app-instrument-template-info [translationPrefix]="translationPrefix()"></app-instrument-template-info>
      }
      @case ('COIN') {
        <app-coins-template-info [translationPrefix]="translationPrefix()"></app-coins-template-info>
      }
      @case ('BANKNOTE') {
        <app-banknote-template-info [translationPrefix]="translationPrefix()"></app-banknote-template-info>
      }
      @case ('ART') {
        <app-art-template-info [translationPrefix]="translationPrefix()"></app-art-template-info>
      }
      @case ('LOAN') {
        <app-loan-template-info [translationPrefix]="translationPrefix()"></app-loan-template-info>
      }
      @case ('SHARES') {
        <app-shares-template-info [translationPrefix]="translationPrefix()"></app-shares-template-info>
      }
      @default {
        {{ `${translationPrefix()}genericMessage` | translate }}
      }
    }
  </div>

  <button class="primary-btn icon-btn" (click)="invokeDownload()">
    <img src="assets/icons/save.svg" />
    {{ translationPrefix() + 'downloadButton' | translate }}
  </button>
}
